export default __webpack_public_path__ + "static/media/inst.41bdbf19.svg";